import React from 'react';

const VideoSection = () => {
  return (
    <section className="video-section">
      <div className="container">
        <div className="video-container">
          <iframe
            width="100%"
            height="600"
            src="https://www.youtube.com/embed/bDu3cZJcqKY"
            title="라떼 소개 영상"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;